import { render, staticRenderFns } from "./GamiMalts.vue?vue&type=template&id=21d4dc09&scoped=true"
import script from "./GamiMalts.vue?vue&type=script&lang=js"
export * from "./GamiMalts.vue?vue&type=script&lang=js"
import style0 from "./GamiMalts.vue?vue&type=style&index=0&id=21d4dc09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d4dc09",
  null
  
)

export default component.exports